import { MS_PER_SECOND } from '@pacevault/engine/time.ts';

export const MIN_OPEN_MS = 1.5 * MS_PER_SECOND;
